import { render, staticRenderFns } from "./capitalFlow.vue?vue&type=template&id=a5350332&scoped=true&"
import script from "./capitalFlow.vue?vue&type=script&lang=js&"
export * from "./capitalFlow.vue?vue&type=script&lang=js&"
import style0 from "./capitalFlow.vue?vue&type=style&index=0&id=a5350332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5350332",
  null
  
)

component.options.__file = "capitalFlow.vue"
export default component.exports